export default class SessionStorageHandler {

  addItem = (key, value) => {
    if (!key || !value) {
      console.log('Both key and value are required');
      return;
    }

    try {
      // Try to add the item to session storage
      sessionStorage.setItem(key, value);
    } catch (e) {
      // Handle QuotaExceededError
      if (e.name === 'QuotaExceededError' || e.code === 22 || e.code === 1014) {
        console.log('Storage quota exceeded.');
        this.clearAll();
      } else {
        console.log(`Error: ${e.message}`);
      }
    }
  };

  getItem = (key) => {
    if (!key) {
      console.log('Key is required');
      return;
    }

    return sessionStorage.getItem(key);
  };

  // Remove a specific item from session storage
  removeItem = (itemKey) => {
    try {
      sessionStorage.removeItem(itemKey);
    } catch (e) {
      console.log(`Error removing item: ${e.message}`);
    }
  };

  // Clear all items from session storage
  clearAll = () => {
    try {
      sessionStorage.clear();
    } catch (e) {
      console.log(`Error clearing storage: ${e.message}`);
    }
  };

}